import { ProcessEnrollmentRequestProto_Body } from "@noom/noom-contracts/noom_contracts/backend/enrollment/b2b/enrollment_event_service";
import { Api } from "@noom/noomscape";

import { useAppContext } from "@/contexts";
import { captureException } from "@/utils/sentry";

// Fire-and-forget lifecycle events for b2b-partner's contact identity store /
// Iterable fan-out. Failures must never block the enrollment flow - events
// carry full state, so a dropped update is retryable server-side.
export const useEnrollmentEvent = () => {
  const { eligibilityInfo, partnerInfo } = useAppContext();
  const eligibilityId = eligibilityInfo?.eligibilityId;
  const partnerId = partnerInfo?.id;

  const sendProcessEnrollmentEvent = async (
    event: Pick<
      ProcessEnrollmentRequestProto_Body,
      "enrollmentStarted" | "screenedOut" | "enrolled"
    >,
  ) => {
    if (!eligibilityId || !partnerId) {
      captureException(
        Error(
          "Attempted to send an enrollment lifecycle event without eligibilityId/partnerId in context",
        ),
      );
      return;
    }

    try {
      await Api.call(
        "partner.processEnrollmentEvent",
        Api.api.partner.processEnrollmentEvent,
        {
          eligibilityId,
          partnerId,
          ...event,
        },
      );
    } catch (e) {
      captureException(e);
    }
  };

  const sendEnrollmentStarted = (email: string) =>
    sendProcessEnrollmentEvent({ enrollmentStarted: { email } });

  const sendScreenedOut = (reason: string) =>
    sendProcessEnrollmentEvent({ screenedOut: { reason } });

  const sendEnrolled = () => sendProcessEnrollmentEvent({ enrolled: {} });

  return {
    sendEnrollmentStarted,
    sendScreenedOut,
    sendEnrolled,
  };
};
